module.exports = __webpack_public_path__ + "media/images/landings/promotion_5/logo-white-dc6c3217c3f2e85d7f55c46064ff2fa5.svg";